import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/core/views/Login.vue'
import * as License from '@/core/license'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  // computed: {
  //   currentRouteName () {
  //     if (process.env.NODE_ENV === 'development') console.log('--> Router, get current route called', this.$Router.name)
  //     return this.$Router.name
  //   }
  // },
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '@/core/views/About.vue')
    },
    {
      path: '/welcome',
      name: 'welcome',
      component: () => import(/* webpackChunkName: "welcome" */ '@/core/views/Welcome.vue'),
      meta: {
        auth: true
      }
    },
    {
      path: '/resetpassword',
      name: 'resetpassword',
      component: () => import(/* webpackChunkName: "Core" */ '@/core/views/ResetPassword')
    },
    {
      path: '/passwordactivated',
      name: 'passwordactivated',
      component: () => import(/* webpackChunkName: "Core" */ '@/core/views/PasswordActivated')
    },
    {
      path: '/nopasswordtoactivate',
      name: 'nopasswordtoactivate',
      component: () => import(/* webpackChunkName: "Core" */ '@/core/views/NoPasswordToActivate')
    },
    {
      path: '/userconfigneeded',
      name: 'userconfigneeded',
      component: () => import(/* webpackChunkName: "Core" */ '@/core/views/UserConfigNeeded')
    },
    {
      path: '/system',
      name: 'system',
      props: true,
      component: () => import(/* webpackChunkName: "System" */ '@/core/views/System'),
      meta: {
        auth: true,
        claims: [License.adminNo]
      }
    },
    {
      path: '/settings',
      name: 'settings',
      props: true,
      component: () => import(/* webpackChunkName: "Settings" */ '@/core/views/Settings'),
      meta: {
        auth: true,
        claims: [License.corporateAdminNo]
      }
    },
    {
      path: '/corporations',
      name: 'corporations',
      props: true,
      component: () => import(/* webpackChunkName: "System" */ '@/core/views/Corporations'),
      meta: {
        auth: true,
        claims: [License.adminNo]
      }
    },
    {
      path: '/corporations/create',
      name: 'createCorporation',
      props: true,
      component: () => import(/* webpackChunkName: "System" */ '@/core/views/Corporation'),
      meta: {
        auth: true,
        claims: [License.adminNo]
      }
    },
    {
      path: '/corporations/:id',
      name: 'editCorporation',
      props: true,
      component: () => import(/* webpackChunkName: "System" */ '@/core/views/Corporation'),
      meta: {
        auth: true,
        claims: [License.adminNo]
      }
    },
    {
      path: '/users',
      name: 'users',
      props: true,
      component: () => import(/* webpackChunkName: "Admin" */ '@/core/views/Users'),
      meta: {
        auth: true,
        claims: [License.adminNo, License.corporateAdminNo]
      }
    },
    {
      path: '/users/create',
      name: 'createUser',
      props: true,
      component: () => import(/* webpackChunkName: "Admin" */ '@/core/views/User'),
      meta: {
        auth: true,
        claims: [License.adminNo, License.corporateAdminNo]
      }
    },
    {
      path: '/users/:id',
      name: 'editUser',
      props: true,
      component: () => import(/* webpackChunkName: "Admin" */ '@/core/views/User'),
      meta: {
        auth: true,
        claims: [License.adminNo, License.corporateAdminNo]
      }
    },
    {
      path: '/usergroups',
      name: 'usergroups',
      props: true,
      component: () => import(/* webpackChunkName: "Admin" */ '@/core/views/UserGroups'),
      meta: {
        auth: true,
        claims: [License.adminNo, License.corporateAdminNo]
      }
    },
    {
      path: '/usergroups/create',
      name: 'createUserGroup',
      props: true,
      component: () => import(/* webpackChunkName: "Admin" */ '@/core/views/UserGroup'),
      meta: {
        auth: true,
        claims: [License.adminNo, License.corporateAdminNo]
      }
    },
    {
      path: '/usergroups/:id',
      name: 'editUserGroup',
      props: true,
      component: () => import(/* webpackChunkName: "Admin" */ '@/core/views/UserGroup'),
      meta: {
        auth: true,
        claims: [License.adminNo, License.corporateAdminNo]
      }
    },

    {
      path: '/facilities',
      name: 'facilities',
      props: true,
      component: () => import(/* webpackChunkName: "Admin" */ '@/core/views/Facilities'),
      meta: {
        auth: true,
        claims: [License.adminNo, License.corporateAdminNo]
      }
    },
    {
      path: '/facilities/create',
      name: 'createFacility',
      props: true,
      component: () => import(/* webpackChunkName: "Admin" */ '@/core/views/Facility'),
      meta: {
        auth: true,
        claims: [License.adminNo, License.corporateAdminNo]
      }
    },
    {
      path: '/facilities/:id',
      name: 'editFacility',
      props: true,
      component: () => import(/* webpackChunkName: "Admin" */ '@/core/views/Facility'),
      meta: {
        auth: true,
        claims: [License.adminNo, License.corporateAdminNo]
      }
    },
    {
      path: '/registrations',
      name: 'registrations',
      component: () => import(/* webpackChunkName: "Inspection" */ '@/modules/delivery-inspection/views/Registrations'),
      meta: {
        auth: true,
        claims: [License.deliveryInspectionNo]
      }
    },
    {
      path: '/inspection/:id',
      name: 'inspection',
      props: true,
      component: () => import(/* webpackChunkName: "Inspection" */ '@/modules/delivery-inspection/views/Inspection'),
      meta: {
        auth: true,
        claims: [License.deliveryInspectionNo]
      }
    },
    {
      path: '/asphalt-delivery',
      name: 'asphalt-delivery',
      component: () => import(/* webpackChunkName: "AsphaltDelivery" */ '@/modules/asphalt-delivery/views/Deliveries'),
      meta: {
        auth: true,
        claims: [License.asphaltDeliveryVehicleNo, License.asphaltDeliveryCarrierNo]
      }
    },
    {
      path: '/asphalt-delivery/edit/:id',
      name: 'editAsphalt-delivery',
      component: () => import(/* webpackChunkName: "AsphaltDelivery" */ '@/modules/asphalt-delivery/views/Edit'),
      meta: {
        auth: true,
        claims: [License.asphaltDeliveryCarrierNo]
      }
    },
    {
      path: '/asphalt-delivery/:id',
      name: 'viewAsphalt-delivery',
      component: () => import(/* webpackChunkName: "AsphaltDelivery" */ '@/modules/asphalt-delivery/views/View'),
      meta: {
        auth: true,
        claims: [License.asphaltDeliveryVehicleNo, License.asphaltDeliveryCarrierNo]
      }
    },
    {
      path: '/asphalt-delivery-vehicles',
      name: 'asphalt-delivery-vehicles',
      component: () => import(/* webpackChunkName: "AsphaltDelivery" */ '@/modules/asphalt-delivery/views/Vehicles'),
      meta: {
        auth: true,
        claims: [License.asphaltDeliveryCarrierNo]
      }
    },
    {
      path: '/asphalt-delivery-vehicles/create',
      name: 'createAsphalt-delivery-vehicles',
      props: true,
      component: () => import(/* webpackChunkName: "AsphaltDelivery" */ '@/modules/asphalt-delivery/views/Vehicle'),
      meta: {
        auth: true,
        claims: [License.asphaltDeliveryCarrierNo]
      }
    },
    {
      path: '/asphalt-delivery-vehicles/edit/:id',
      name: 'editAsphalt-delivery-vehicles',
      component: () => import(/* webpackChunkName: "AsphaltDelivery" */ '@/modules/asphalt-delivery/views/Vehicle'),
      meta: {
        auth: true,
        claims: [License.asphaltDeliveryCarrierNo]
      }
    },
    {
      path: '/wheel-loader-registrations',
      name: 'wheel-loader-registrations',
      component: () => import(/* webpackChunkName: "WheelLoader" */ '@/modules/wheel-loader/views/Registrations'),
      meta: {
        auth: true,
        claims: [License.wheelLoaderNo]
      }
    },
    {
      path: '/wheel-loader-registration/create',
      name: 'create-wheel-loader-registration',
      component: () => import(/* webpackChunkName: "WheelLoader" */ '@/modules/wheel-loader/views/Registration'),
      meta: {
        auth: true,
        claims: [License.wheelLoaderNo]
      }
    },
    {
      path: '/wheel-loader-registration/:id',
      name: 'edit-wheel-loader-registration',
      props: true,
      component: () => import(/* webpackChunkName: "WheelLoader" */ '@/modules/wheel-loader/views/Registration'),
      meta: {
        auth: true,
        claims: [License.wheelLoaderNo]
      }
    },
    {
      path: '/wheel-loader-registration/:id',
      name: 'finish-wheel-loader-registration',
      props: true,
      component: () => import(/* webpackChunkName: "WheelLoader" */ '@/modules/wheel-loader/views/FinishRegistration'),
      meta: {
        auth: true,
        claims: [License.wheelLoaderNo]
      }
    },
    {
      path: '/wheel-loader-registration/:id/weight',
      name: 'add-wheel-loader-weight',
      props: true,
      component: () => import(/* webpackChunkName: "WheelLoader" */ '@/modules/wheel-loader/views/Weight'),
      meta: {
        auth: true,
        claims: [License.wheelLoaderNo]
      }
    },
    {
      path: '/wheel-loader-registrationprint-zpl/:id',
      name: 'print-wheel-loader-zpl',
      props: true,
      component: () => import(/* webpackChunkName: "ScanMobile" */ '@/modules/wheel-loader/views/RegistrationPrintZPL'),
      meta: {
        auth: true,
        claims: [License.wheelLoaderNo]
      }
    },
    {
      path: '/reports/registrations',
      name: 'reports-registrations',
      props: true,
      component: () => import(/* webpackChunkName: "Reports" */ '@/modules/reports/views/Registrations'),
      meta: {
        auth: true,
        claims: [License.reportsNo]
      }
    },
    {
      path: '/reports/registrationsSimple',
      name: 'reports-registrations-simple',
      props: true,
      component: () => import(/* webpackChunkName: "Reports" */ '@/modules/reports/views/RegistrationsSimple'),
      meta: {
        auth: true,
        claims: [License.reportsSimpleNo]
      }
    },
    {
      path: '/reports/registrationconfirmationprint/:id',
      name: 'print-registration-confirmation',
      props: true,
      component: () => import(/* webpackChunkName: "Reports" */ '@/modules/reports/views/RegistrationConfirmationPrint'),
      meta: {
        auth: true,
        claims: [License.reportsNo]
      }
    },
    {
      path: '/translations',
      name: 'translations',
      props: true,
      component: () => import(/* webpackChunkName: "Translations" */ '@/core/views/Translations'),
      meta: {
        auth: true,
        claims: [License.corporateAdminNo]
      }
    },
    {
      path: '/pre-registration-registrations',
      name: 'pre-registration-registrations',
      component: () => import(/* webpackChunkName: "PreRegistration" */'@/modules/pre-registration/views/Pre-Registrations'),
      meta: {
        auth: true,
        claims: [License.preRegistrationNo]
      }
    },
    {
      path: '/pre-registration-registrations/arrival',
      name: 'pre-registration-registrations-arrival',
      props: true,
      component: () => import(/* webpackChunkName: "PreRegistration" */'@/modules/pre-registration/views/Pre-Registrations'),
      meta: {
        auth: true,
        claims: [License.preRegistrationNo]
      }
    },
    {
      path: '/pre-registration-registration/create',
      name: 'create-pre-registration-registration',
      component: () => import(/* webpackChunkName: "PreRegistration" */ '@/modules/pre-registration/views/Pre-Registration'),
      meta: {
        auth: true,
        claims: [License.preRegistrationNo]
      }
    },
    {
      path: '/pre-registration-registration/:id',
      name: 'edit-pre-registration-registration',
      props: true,
      component: () => import(/* webpackChunkName: "PreRegistration" */ '@/modules/pre-registration/views/Pre-Registration'),
      meta: {
        auth: true,
        claims: [License.preRegistrationNo]
      }
    },
    {
      path: '/classifier-registrations',
      name: 'classifier-registrations',
      component: () => import(/* webpackChunkName: "Classifier" */'@/modules/classifier/views/ClassifierRegistrations'),
      meta: {
        auth: true,
        claims: [License.classifierNo]
      }
    },
    {
      path: '/classifier-registration/:id',
      name: 'edit-classifier-registration',
      props: true,
      component: () => import(/* webpackChunkName: "Classifier" */ '@/modules/classifier/views/ClassifierRegistration'),
      meta: {
        auth: true,
        claims: [License.classifierNo]
      }
    },
    {
      path: '/scan-code-registrations',
      name: 'scan-code-registrations',
      component: () => import(/* webpackChunkName: "ScanCode" */ '@/modules/scan-code/views/Registrations'),
      meta: {
        auth: true,
        claims: [License.scanCodeNo]
      }
    },
    {
      path: '/scan-code-registration/create',
      name: 'create-scan-code-registration',
      component: () => import(/* webpackChunkName: "ScanCode" */ '@/modules/scan-code/views/Registration'),
      meta: {
        auth: true,
        claims: [License.scanCodeNo]
      }
    },
    {
      path: '/scan-code-registration/:id',
      name: 'edit-scan-code-registration',
      props: true,
      component: () => import(/* webpackChunkName: "ScanCode" */ '@/modules/scan-code/views/Registration'),
      meta: {
        auth: true,
        claims: [License.scanCodeNo]
      }
    },
    {
      path: '/scan-code-registration/:id/weight',
      name: 'add-scan-code-weight',
      props: true,
      component: () => import(/* webpackChunkName: "ScanCode" */ '@/modules/scan-code/views/Weight'),
      meta: {
        auth: true,
        claims: [License.scanCodeNo]
      }
    },
    {
      path: '/scan-code-deliveries',
      name: 'scan-code-deliveries',
      component: () => import(/* webpackChunkName: "ScanCode" */ '@/modules/scan-code/views/Deliveries'),
      meta: {
        auth: true,
        claims: [License.scanCodeNo]
      }
    },
    {
      path: '/scan-code-scan/create',
      name: 'create-scan-code-scan',
      component: () => import(/* webpackChunkName: "ScanCode" */ '@/modules/scan-code/views/Scan'),
      meta: {
        auth: true,
        claims: [License.scanCodeNo]
      }
    },
    {
      path: '/scan-code-scan/:id',
      name: 'edit-scan-code-scan',
      props: true,
      component: () => import(/* webpackChunkName: "ScanCode" */ '@/modules/scan-code/views/Scan'),
      meta: {
        auth: true,
        claims: [License.scanCodeNo]
      }
    },
    {
      path: '/nominations',
      name: 'nominations',
      component: () => import(/* webpackChunkName: "Nominations" */ '@/modules/nomination/views/Nominations'),
      meta: {
        auth: true,
        claims: [License.nominationNo]
      }
    },
    {
      path: '/unloading-fuel',
      name: 'unloading-fuel',
      component: () => import(/* webpackChunkName: "UnloadingFuel" */ '@/modules/unloading-fuel/views/UnloadingFuel'),
      meta: {
        auth: true,
        claims: [License.unloadingFuelNo]
      }
    },
    {
      path: '/unloading-fuel-create-registration',
      name: 'unloading-fuel-create-registration',
      component: () => import(/* webpackChunkName: "UnloadingFuel" */ '@/modules/unloading-fuel/views/CreateRegistration'),
      meta: {
        auth: true,
        claims: [License.unloadingFuelNo]
      }
    },
    {
      path: '/batch-registration',
      name: 'batch-registration',
      component: () => import(/* webpackChunkName: "BatchRegistrations" */ '@/modules/batch-registration/views/BatchRegistrations'),
      meta: {
        auth: true,
        claims: [License.batchRegistrationNo]
      }
    },
    {
      path: '/batch-registration-create-registration',
      name: 'batch-registration-create-registration',
      component: () => import(/* webpackChunkName: "BatchRegistrations" */ '@/modules/batch-registration/views/CreateBatchRegistration'),
      meta: {
        auth: true,
        claims: [License.batchRegistrationNo]
      }
    },
    {
      path: '/scan-mobile-registrations',
      name: 'scan-mobile-registrations',
      component: () => import(/* webpackChunkName: "ScanMobile" */ '@/modules/scan-mobile/views/Registrations'),
      meta: {
        auth: true,
        claims: [License.scanMobileNo]
      }
    },
    {
      path: '/scan-mobile-registration/create',
      name: 'create-scan-mobile-registration',
      component: () => import(/* webpackChunkName: "ScanMobile" */ '@/modules/scan-mobile/views/Registration'),
      meta: {
        auth: true,
        claims: [License.scanMobileNo]
      }
    },
    {
      path: '/scan-mobile-registration/:id',
      name: 'edit-scan-mobile-registration',
      props: true,
      component: () => import(/* webpackChunkName: "ScanMobile" */ '@/modules/scan-mobile/views/Registration'),
      meta: {
        auth: true,
        claims: [License.scanMobileNo]
      }
    },
    {
      path: '/scan-mobile-registration/:id/weight',
      name: 'add-scan-mobile-weight',
      props: true,
      component: () => import(/* webpackChunkName: "ScanMobile" */ '@/modules/scan-mobile/views/Weight'),
      meta: {
        auth: true,
        claims: [License.scanMobileNo]
      }
    },
    {
      path: '/scan-mobile-registrationprint/:id',
      name: 'print-scan-mobile',
      props: true,
      component: () => import(/* webpackChunkName: "ScanMobile" */ '@/modules/scan-mobile/views/RegistrationPrint'),
      meta: {
        auth: true,
        claims: [License.scanMobileNo]
      }
    },
    {
      path: '/scan-mobile-registrationprint-zpl/:id',
      name: 'print-scan-mobile-zpl',
      props: true,
      component: () => import(/* webpackChunkName: "ScanMobile" */ '@/modules/scan-mobile/views/RegistrationPrintZPL'),
      meta: {
        auth: true,
        claims: [License.scanMobileNo]
      }
    },
    {
      path: '/scan-mobile-scan/create',
      name: 'create-scan-mobile-scan',
      component: () => import(/* webpackChunkName: "ScanMobile" */ '@/modules/scan-mobile/views/Scan'),
      meta: {
        auth: true,
        claims: [License.scanMobileNo]
      }
    },
    {
      path: '/scan-mobile-scan/:id',
      name: 'edit-scan-mobile-scan',
      props: true,
      component: () => import(/* webpackChunkName: "ScanMobile" */ '@/modules/scan-mobile/views/Scan'),
      meta: {
        auth: true,
        claims: [License.scanMobileNo]
      }
    },
    {
      path: '/storage-map',
      name: 'storage-map',
      component: () => import(/* webpackChunkName: "StorageMap" */ '@/modules/storage-map/views/map'),
      meta: {
        auth: true,
        claims: [License.storageMapNo]
      }
    },
    {
      path: '/storage-staticmap',
      name: 'storage-staticmap',
      component: () => import(/* webpackChunkName: "StorageMap" */ '@/modules/storage-map/views/staticmap')
    },
    {
      path: '/create-vehicles',
      name: 'create-vehicles',
      component: () => import('@/modules/create-vehicles/views/Vehicles'),
      meta: {
        auth: true,
        claims: [License.createVehiclesNo]
      }
    },
    {
      path: '/create-vehicle',
      name: 'create-vehicle',
      component: () => import('@/modules/create-vehicles/views/Vehicle'),
      meta: {
        auth: true,
        claims: [License.createVehiclesNo]
      }
    },
    {
      path: '/workplaces',
      name: 'workplaces',
      component: () => import('@/modules/workplaces/views/Deliveries'),
      meta: {
        auth: true,
        claims: [License.worlPlacesNo]
      }
    },
    {
      path: '/workplace',
      name: 'workplace',
      component: () => import('@/modules/workplaces/views/View'),
      meta: {
        auth: true,
        claims: [License.worlPlacesNo]
      }
    },
    {
      path: '/workplace-edit',
      name: 'workplace-edit',
      component: () => import('@/modules/workplaces/views/Edit'),
      meta: {
        auth: true,
        claims: [License.worlPlacesNo]
      }
    }
  ]
})
